import type { SceneHotspot } from './types';

interface HotspotButtonProps {
  hotspot: SceneHotspot;
  isActive: boolean;
  isVisited: boolean;
  onClick: () => void;
}

export function HotspotButton({ hotspot, isActive, isVisited, onClick }: HotspotButtonProps) {
  const { rect, label, kind } = hotspot;

  // Flip clue card: open left if in right half, open up if in bottom half
  const flipX = rect.xPct > 50;
  const flipY = rect.yPct > 50;

  const classNames = [
    'escape-hotspot',
    isActive ? 'escape-hotspot--active' : '',
    isVisited ? 'escape-hotspot--visited' : '',
  ].filter(Boolean).join(' ');

  let iconClass = 'fa-magnifying-glass';
  if (isVisited && kind === 'item') iconClass = 'fa-box-open';
  else if (isVisited && kind === 'clue') iconClass = 'fa-circle-info';

  return (
    <div
      className="escape-hotspot-wrapper"
      style={{
        left: `${rect.xPct}%`,
        top: `${rect.yPct}%`,
        width: `${rect.wPct}%`,
        height: `${rect.hPct}%`,
      }}
    >
      <button
        className={classNames}
        aria-label={`Examine: ${label}${isVisited ? ' (examined)' : ''}`}
        aria-expanded={isActive}
        onClick={onClick}
        type="button"
      >
        <span className="escape-hotspot__ring" aria-hidden="true" />
        <i className={`fa-solid ${iconClass} escape-hotspot__icon`} aria-hidden="true" />
      </button>

      {isActive && (
        <div
          className={[
            'escape-clue-card',
            flipX ? 'escape-clue-card--flip-x' : '',
            flipY ? 'escape-clue-card--flip-y' : '',
          ].filter(Boolean).join(' ')}
          role="tooltip"
        >
          <p className="escape-clue-card__label">{label}</p>
          <p className="escape-clue-card__text">{hotspot.narrativeText}</p>
          {hotspot.clueValue !== undefined && (
            <p className="escape-clue-card__value">
              <i className="fa-solid fa-hashtag" aria-hidden="true" />
              {' '}{hotspot.clueValue}
            </p>
          )}
          {kind === 'item' && isVisited && (
            <p className="escape-clue-card__granted">
              <i className="fa-solid fa-box-open" aria-hidden="true" /> Item collected
            </p>
          )}
          {kind === 'item' && !isVisited && (
            <p className="escape-clue-card__granted">
              <i className="fa-solid fa-gift" aria-hidden="true" /> Contains a glyph
            </p>
          )}
        </div>
      )}
    </div>
  );
}
